import React, { useContext } from "react";
import DentalLogo from "../assets/images/DLS_logo.svg";
import { useNavigate } from "react-router-dom";

import { UserContext } from "../contexts/UserContext";

const Header = () => {
  const { userData, clearUserData } = useContext(UserContext);
  const firstLetterFirstName = userData?.user?.userFirstName?.charAt(0) || "";
  const firstLetterLastName = userData?.user?.userLastName?.charAt(0) || "";
  const navigate = useNavigate();
  const LogoutUser = () => {
    clearUserData();
    navigate("/");
  };
  const ProfilePage = () => {
    navigate("/edit-profile");
  };
  const headerStyle = {
    boxShadow: "0px 4px 6px rgba(30, 81, 130, 0.1)",
  };
  return (
    <header className="bg-blue-400 fixed w-full z-10" style={headerStyle}>
      <div className="container mx-auto flex justify-between items-center py-3 px-2 sm:py-5 sm:px-4">
        <div className="text-2xl font-bold text-blue-500">
          <a href="/dashboard">
            <img
              src={DentalLogo}
              alt="Login"
              className="w-[180px] sm:w-[302px] h-8 sm:h-[50px] xl:scale-90 3xl:scale-100"
            />
          </a>
        </div>

        <div className="flex items-center bg-gray-100 gap-3 sm:gap-8">
          <div
            onClick={ProfilePage}
            className="flex items-center space-x-2 sm:space-x-3 cursor-pointer"
          >
            <div className="relative inline-block w-8 h-8 rounded-lg p-[1px]">
              <p className="bg-gradient-to-b [--tw-gradient-from:#9BC5F2] [--tw-gradient-via:#7FADDC] [--tw-gradient-to:#2C6398] from-[--tw-gradient-from] via-[--tw-gradient-via] to-[--tw-gradient-to] rounded-lg w-8 h-8 flex items-center justify-center text-white text-lg sm:text-2xl font-roboto font-medium">
                {`${firstLetterFirstName}${firstLetterLastName}`}
              </p>
            </div>
            <span className="text-base sm:text-lg 3xl:text-2xl font-medium font-inter text-gray-600 hidden sm:inline-flex">
              {userData?.user?.userFirstName} {userData?.user?.userLastName}
            </span>
          </div>

          <button
            className="px-3 py-1 text-base sm:px-5 sm:py-2 sm:text-2xl xl:!text-base 3xl:!text-2xl border uppercase border-blue-500 text-blue font-robotoBold rounded-lg hover:bg-blue-800 hover:border-blue-800 hover:text-white transition duration-300"
            onClick={LogoutUser}
          >
            LOG-OUT
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
